import React, { useEffect, useMemo, useRef, useState } from "react";
import "./DecadeNavBar.css";

export default function DecadeNavBarDesktop({
  decades,
  activeDecade,
  onDecadeClick,
  showDecadeNav,
}) {
  const containerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const total = decades.length;

  useEffect(() => {
    const updateWidth = () => {
      if (containerRef.current) {
        const parentWidth = containerRef.current.parentElement?.clientWidth || 0;
        setContainerWidth(parentWidth || window.innerWidth || 0);
      }
    };

    updateWidth();
    window.addEventListener("resize", updateWidth);

    let observer;
    if (containerRef.current && typeof ResizeObserver !== "undefined") {
      observer = new ResizeObserver(updateWidth);
      observer.observe(containerRef.current);
    }

    return () => {
      window.removeEventListener("resize", updateWidth);
      if (observer) observer.disconnect();
    };
  }, []);

  const rowCount = useMemo(() => {
    if (total <= 0) return 1;
    const width = containerWidth || window.innerWidth;
    const gapPx = 8; // 对应 .decade-row 的 0.5rem 间距
    const minButtonWidthPx = 78; // decade 按钮最小舒适宽度估算
    const maxColsFit = Math.max(
      1,
      Math.floor((width + gapPx) / (minButtonWidthPx + gapPx))
    );

    // 规则：两行放得下就优先两行，否则三行，再不行四行
    if (Math.ceil(total / 2) <= maxColsFit) return 2;
    if (Math.ceil(total / 3) <= maxColsFit) return 3;
    return Math.min(4, total);
  }, [total, containerWidth]);

  const rowsData = useMemo(() => {
    const rows = [];
    if (total === 0) return rows;

    const baseSize = Math.floor(total / rowCount);
    const extra = total % rowCount;
    let cursor = 0;

    for (let i = 0; i < rowCount; i++) {
      const size = baseSize + (i < extra ? 1 : 0);
      rows.push(decades.slice(cursor, cursor + size));
      cursor += size;
    }

    return rows;
  }, [decades, total, rowCount]);

  return (
    <div
      ref={containerRef}
      className={`decade-navbar${
        showDecadeNav === false ? " hide-on-scroll-up" : ""
      }`}
    >
      {rowsData.map((row, rowIdx) => (
        <div className="decade-row" key={`row-${rowIdx}`}>
          {row.map((decade) => (
            <button
              key={decade}
              className={`decade-btn${activeDecade === decade ? " active" : ""}`}
              onClick={() => onDecadeClick(decade)}
            >
              {decade}
            </button>
          ))}
        </div>
      ))}
    </div>
  );
}
